import { MediaType } from "./mediaClass";


export enum AssetType {
  IMAGE = 'image',
  VIDEO = 'video',
}

export enum OwnerType {
  USER = 'user',
  ENTERPRISE = 'enterprise',
}

export interface AssetProperties {
  size?: number
}

// Nomenclature pour les tags d'assets: "studio.logos", "studio.background.images", "studio.background.videos", "studio.foreground.videos", "studio.foreground.images"

export interface Asset {
  id?: string,
  type?: AssetType,
  tag?: string,
  studioMediaType?: MediaType, // Calculated in asset management service.
  assetUrl?: string,
  title?: string,
  assetThumbnailUrl?: string,
  assetDownloadUrl?: string,
  status?: string,
  ownerType?: OwnerType,
  ownerId?: string,
  enterpriseId?: string,
  createdBy?: string,
  createdDate?: number,
  properties?: AssetProperties,
}

export var tagMediaTypeMapping =  {
  'STUDIO_LOGO': MediaType.LOGO,
  'STUDIO_BACKGROUND_IMAGE': MediaType.BG_IMAGE,
  'STUDIO_BACKGROUND_VIDEO': MediaType.BG_VIDEO,
  'STUDIO_VIDEO': MediaType.FG_VIDEO,
  'STUDIO_IMAGE': MediaType.FG_IMAGE
}
